module.exports = __webpack_public_path__ + "static/media/checkCircleIcon.9fee9212.svg";